import React from 'react'

import { CheckCircle } from '@phosphor-icons/react'
import { Row, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { GROW_SECTION_CHECKLIST_ITEMS } from './constants'
import { Container } from './styles'

function GrowSectionCheckboxList() {
  const { isMobile } = useResponsiveLayout()

  return (
    <Container
      gridTemplateColumns={[
        '1fr',
        '1fr',
        'repeat(2, 1fr)',
        'repeat(2, 1fr)',
        'repeat(3, 1fr)',
      ]}
    >
      {GROW_SECTION_CHECKLIST_ITEMS.map(item => (
        <Row alignCenter gap={2} key={item.id}>
          <CheckCircle size={20} weight="fill" />

          <Text body medium screen14={isMobile} screen18={!isMobile}>
            {item.caption}
          </Text>
        </Row>
      ))}
    </Container>
  )
}

export default GrowSectionCheckboxList
